import React from "react";
import ProductHello from "../components/productHelo"
import ProductsSection from "../components/ProductsSection"
import WhyChooseUs from "../components/WhyChooseUs";


const HomePage = ({ isDarkMode }) => {
  
  const facts = [
    "Our team has over 20 years of combined experience.",
    "We’ve completed 100+ successful projects across various industries.",
    "We are committed to providing sustainable tech solutions.",
  ];

  return (
    <>
      <ProductHello isDarkMode={isDarkMode} />
      <ProductsSection isDarkMode={isDarkMode} />
      <WhyChooseUs isDarkMode={isDarkMode} facts={facts} />
    
  
    
    </>
  );
};

export default HomePage;
